import * as React from "react"

const Soundcloud = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="#EEE"
        fillRule="evenodd"
        d="M13.463 7.636c.213-.076.388-.14.627-.14 1.107 0 1.912 1.007 1.912 2.114a2.019 2.019 0 0 1-2.012 2.013H8.354c-.1 0-.201-.1-.201-.201V4.88c0-.101 0-.202.201-.302.403-.1.805-.202 1.308-.202 1.912 0 3.422 1.41 3.623 3.321.063-.02.122-.042.178-.062Zm-6.92 3.785a.217.217 0 0 1-.202.202c-.1 0-.201-.1-.201-.201l-.1-1.711.1-4.227c0-.1.1-.2.201-.2.1 0 .202.1.202.2l.1 4.227-.1 1.71ZM2.316 6.793c-.1 0-.202.1-.202.2l-.1 2.718.1 1.811c0 .1.101.1.101.1.1 0 .1-.1.1-.1l.101-1.811V6.994c0-.1-.1-.201-.1-.201ZM.303 8.2c-.1-.1-.1 0-.1 0L0 9.711l.201 1.51s0 .1.101.1c0 0 .1 0 .1-.1l.202-1.51L.303 8.2Zm4.026 3.422c.1 0 .2-.1.2-.201L4.63 9.71l-.1-3.723c0-.101-.1-.202-.201-.202s-.202.1-.202.202l-.1 3.723.1 1.71c0 .101.1.202.202.202Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default Soundcloud
